// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1Nxfd","containerItemsCenter":"Skeleton_containerItemsCenter__G9FOX"};